import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { WorkshopJobcardAddBookingNotesComponent } from '../workshop-jobcard-customer-details/workshop-jobcard-add-booking-notes/workshop-jobcard-add-booking-notes.component';
import { ServiceRequestService } from '../../../../services';

@Component({
  selector: 'app-workshop-jobcard-extras',
  templateUrl: './workshop-jobcard-extras.component.html',
  styleUrls: ['./workshop-jobcard-extras.component.scss']
})
export class WorkshopJobcardExtrasComponent {

  @Input() jobcard: any;
  @Output() jobcardChange = new EventEmitter<any>();

  @ViewChild('bayDropdown') bayDropdown: any;
  public bays: any[] = [];
  public bay: any = {};

  constructor(
    private helpersService: HelpersService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private serviceRequest: ServiceRequestService,
  ) {

  }

  ngOnInit() {
    if(this.jobcard.collectionsDeliveries?.allowCollection) {
      this.jobcard.itemIsHere = false;
    }
    this.getBays();
  }


  addBookingNotes() {
    const modalRef = this.modalService.open(WorkshopJobcardAddBookingNotesComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'md'
    });

    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {

      },
    );
  }

  clearBookingNotes() {
    this.jobcard.clientNotes = '';
    this.jobcardChange.emit({ ...this.jobcard });
  }

  onBayTagNoChanged(bayTagNo) {
    if (this.bays.length > 0) {
      const found = this.bays.find(x => x.id === bayTagNo);
      const label = found?.bayTag ?? bayTagNo;
      this.jobcard.bayNo = label;
     
    } else { 
     
    }
    this.getBays();
  }

  getBays() {
    this.serviceRequest.getBays(this.helpersService.getPartnerData().ID).subscribe(res => {
      this.bays = res.map(bay => ({
        ...bay,
        value: bay.id,
        label: bay.bayTag + ' - ' + (bay.itemCount) + ' ' + this.translate.instant("bikeshop.modal.add_edit_user.bikes"),
        itemCount: bay.itemCount,
      }));
      if (this.bays.length > 0) {
       
      }
    });
  }

}
